import React from "react";
import styled from "styled-components";
import { DHKS_INFO } from "../../Models/CompanyInfoData";

const Footer = () => {
  const handleFamilySite = (e) => {
    const url = e.target.value;
    if (url) window.open(url, "_blank");
  };

  return (
    <FooterContainer>
      <InnerWrapper>
        <TopSection>
          <FooterLogo>{DHKS_INFO.companyKRName}(주)</FooterLogo>
          <FamilySiteSelect onChange={handleFamilySite}>
            <option value="">Family Site</option>
            <option value="https://www.yccorp.com/kr">YC</option>
            <option value="https://exicon.co.kr/kr">EXICON</option>
            <option value="https://semcns.com">SEMCNS</option>
            <option value="http://www.semtek.co.kr">SEMTEK</option>
          </FamilySiteSelect>
        </TopSection>

        <InfoSection>
          <InfoGrid>
            <div className="info-item">
              <span className="label">ADDRESS</span>
              <p>{DHKS_INFO.contact.main.address}</p>
            </div>
            <div className="info-item">
              <span className="label">TEL</span>
              <p>{DHKS_INFO.contact.main.tel}</p>
            </div>
            <div className="info-item">
              <span className="label">FAX</span>
              <p>{DHKS_INFO.contact.main.fax}</p>
            </div>
          </InfoGrid>
        </InfoSection>

        <BottomSection>
          <p className="copyright">© 2026 DHK Solution. All Rights Reserved.</p>
          <FooterLinks></FooterLinks>
        </BottomSection>
      </InnerWrapper>
    </FooterContainer>
  );
};

export default Footer;

const FooterContainer = styled.footer`
  width: 100%;
  background-color: #1a1a1a;
  color: #888;
  padding: 60px 0 40px 0;
  border-top: 1px solid #333;
`;

const InnerWrapper = styled.div`
  width: 90%;
  max-width: 1400px;
  margin: 0 auto;
`;

const TopSection = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 40px;
  padding-bottom: 30px;
  border-bottom: 1px solid #2a2a2a;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 20px;
  }
`;

const FooterLogo = styled.div`
  font-size: 1.5rem;
  font-weight: 800;
  color: #fff;
  letter-spacing: 2px;
`;

const FamilySiteSelect = styled.select`
  background-color: transparent;
  color: #ccc;
  border: 1px solid #444;
  padding: 8px 15px;
  font-size: 0.85rem;
  outline: none;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    border-color: #00d2ff;
    color: #fff;
  }

  option {
    background-color: #1a1a1a;
    color: #fff;
  }
`;

const InfoSection = styled.div`
  margin-bottom: 40px;
`;

const InfoGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 40px;

  .info-item {
    .label {
      display: block;
      font-size: 0.75rem;
      font-weight: 700;
      color: #00d2ff;
      margin-bottom: 8px;
      letter-spacing: 1px;
    }
    p {
      font-size: 0.95rem;
      color: #bbb;
      line-height: 1.5;
    }
  }

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 20px;
  }
`;

const BottomSection = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 0.85rem;

  .copyright {
    letter-spacing: 0.5px;
  }

  @media (max-width: 768px) {
    flex-direction: column-reverse;
    align-items: flex-start;
    gap: 15px;
  }
`;

const FooterLinks = styled.div`
  display: flex;
  gap: 20px;

  span {
    cursor: pointer;
    transition: color 0.3s ease;

    &:first-child {
      color: #fff;
      font-weight: 600;
    }

    &:hover {
      color: #00d2ff;
    }
  }
`;
